import * as Global from "../classes/context";
// import { DeviceEventEmitter } from "react-native";
import { API_PLUS_URL } from "./cyMyManagerUtils";
import { Operatore } from "./cyMyManagerPlusInterface";

export const setBodyReq = (body: any): any => {
  // let globalTmp = Global.initGlobalContextHookless();

  // if (DeviceEventEmitter.listenerCount('main_getContext') > 0)
  //   DeviceEventEmitter.emit('main_getContext', globalTmp);

  // if (globalTmp.onPremisesUrl != '')
  //   return { "data": body };
  // else
    return body
}

export const getURLServer = (): string => {
  // let globalTmp = Global.initGlobalContextHookless();

  // if (DeviceEventEmitter.listenerCount('main_getContext') > 0)
  //   DeviceEventEmitter.emit('main_getContext', globalTmp);

  // if (globalTmp.onPremisesUrl != '')
  //   return globalTmp.onPremisesUrl + '/api/v1/';
  // else
    return API_PLUS_URL;
}

export const getBodyOperator = (body: any, operatore: Operatore) => {
  // let globalTmp = Global.initGlobalContextHookless();

  // if (DeviceEventEmitter.listenerCount('main_getContext') > 0)
  //   DeviceEventEmitter.emit('main_getContext', globalTmp);

  // if (globalTmp.onPremisesUrl != '')
  //   body = { "operatore": { "operatore": operatore, "plusMaxNumOper": globalTmp.profiloCliente?.products?.find(x => x.tipo === "CMMP")?.plusMaxNumOper ?? 0 } };

  return body
}